import productAPI from "@/app/apis/main/product/product-api.js"

export default {
	/**
	 * @return {object} product list
	 * @param {*} productDetails - Contains pagination data
	 * @param productId
	 */
	async getProducts(petId, productDetails) {
		return productAPI.getProducts(petId, productDetails)
	},

	async getPublicProducts(queryParams) {
		return productAPI.getPublicProducts(queryParams)
	},
	async getPublicCategoryProducts(queryParams) {
		return productAPI.getPublicCategoryProducts(queryParams)
	},
	async getPublicProductDetails(bundleId) {
		return productAPI.getPublicProductDetails(bundleId)
	},
	/**
	 *
	 * @param {Integer} productId
	 * @returns
	 */
	async getProductsDogDetails(productId) {
		return productAPI.getProductsDogDetails(productId)
	},

	/**
	 * @return {object} product details
	 * @param {*} productId - product id
	 */
	async getProductById(productId) {
		return productAPI.getProductById(productId)
	},

	/**
	 * @return {object} product types
	 **/
	async getProductTypes() {
		return productAPI.getProductTypes()
	},

	/**
	 * @return {object} bundles list - lowest price by product type
	 * @param {*} petId - active pet id
	 **/
	async getBundlesLowestPrice(petId) {
		return productAPI.getBundlesLowestPrice(petId)
	},

	/**
	 * @return {object} bundle list
	 * @param {*} bundleDetails - Contains pagination data
	 *
	 **/
	async getBundles(bundleDetails) {
		return productAPI.getBundles(bundleDetails)
	},

	/**
	 * @return {object} bundle list
	 * @param {*} bundleDetails - Contains pagination data
	 *
	 **/
	async getPetOrderBundles(bundleDetails) {
		return productAPI.getPetOrderBundles(bundleDetails)
	},

	/**
	 * @param {*} orderId - orderId
	 *
	 **/
	async getPetOrder(orderId) {
		return productAPI.getPetOrder(orderId)
	},

	/**
	 * @param {*} bundleId - bundleId
	 *
	 **/
	async getBundleById(bundleId, petId) {
		return productAPI.getBundleById(bundleId, petId)
	},
}
